export default "__VITE_ASSET__DxcAmXfF__"